export const basePath =
	process.env.REACT_APP_BASE_PATH || "http://127.0.0.1:8000/api/v1/";

export const APIurls = {
	// auth
	admin: "auth/admin",
	adminProfile: "admin",

	// publishers
	publishers: "publishers",

	// settlements
	settlements: "settlements",

	//transactions
	transactions: "transactions",

	// articles
	articles: "articles",

	//currencies
	currencies: "/stripe/currencies",

	// FX quote (publisher currency -> USD)
	fxQuote: "/stripe/fx-quote",
	updatePassword: "/admin/auth/password",

	// onboarding requests
	onboardingRequests: "onboarding-requests",
};

export const CMS = {
  Beehiiv: 'Beehiiv',
  Ghost: 'Ghost',
  WordPress: 'WordPress',
  Direct: 'Direct'
}
